import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SocialInteractions = ({ 
  reactions = [],
  comments = [],
  onReact,
  onComment,
  onShare 
}) => {
  const [commentText, setCommentText] = useState('');
  const [activeTab, setActiveTab] = useState('reactions');

  const reactionTypes = [
    { id: 'fire', icon: 'Flame', label: 'Огонь', count: 234 },
    { id: 'heart', icon: 'Heart', label: 'Нравится', count: 567 },
    { id: 'star', icon: 'Star', label: 'Избранное', count: 123 },
    { id: 'bookmark', icon: 'Bookmark', label: 'Сохранить', count: 89 }
  ];

  const handleCommentSubmit = (e) => {
    e?.preventDefault();
    if (commentText?.trim()) {
      onComment(commentText);
      setCommentText('');
    }
  };

  return (
    <div className="social-interactions bg-card rounded-lg border border-border p-6">
      <div className="interactions-tabs flex items-center gap-4 mb-6 border-b border-border">
        <button
          onClick={() => setActiveTab('reactions')}
          className={`tab-button pb-3 px-2 text-sm font-heading font-medium transition-colors duration-200 ${
            activeTab === 'reactions' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
          }`}
        >
          Реакции
        </button>
        <button
          onClick={() => setActiveTab('comments')}
          className={`tab-button pb-3 px-2 text-sm font-heading font-medium transition-colors duration-200 ${
            activeTab === 'comments' ?'text-primary border-b-2 border-primary' :'text-muted-foreground hover:text-foreground'
          }`}
        >
          Комментарии ({comments?.length})
        </button>
      </div>
      {activeTab === 'reactions' && (
        <div className="reactions-content">
          <div className="reaction-buttons grid grid-cols-2 gap-3 mb-4">
            {reactionTypes?.map(reaction => (
              <Button
                key={reaction?.id}
                variant="outline"
                onClick={() => onReact(reaction?.id)}
                className="justify-start"
              >
                <Icon name={reaction?.icon} size={18} color="var(--color-primary)" />
                <span className="ml-2">{reaction?.label}</span>
                <span className="ml-auto text-muted-foreground">{reaction?.count}</span>
              </Button>
            ))}
          </div>

          <Button
            variant="secondary"
            fullWidth
            iconName="Share2"
            iconPosition="left"
            onClick={onShare}
          >
            Поделиться моментом
          </Button>
        </div>
      )}
      {activeTab === 'comments' && (
        <div className="comments-content">
          <form onSubmit={handleCommentSubmit} className="comment-form mb-4">
            <Input
              type="text"
              placeholder="Добавить комментарий..."
              value={commentText}
              onChange={(e) => setCommentText(e?.target?.value)}
              className="mb-2"
            />
            <Button
              type="submit"
              variant="default"
              size="sm"
              disabled={!commentText?.trim()}
            >
              Отправить
            </Button>
          </form>

          <div className="comments-list space-y-4 max-h-64 overflow-y-auto">
            {comments?.map(comment => (
              <div key={comment?.id} className="comment-item flex gap-3">
                <div className="comment-avatar w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="User" size={16} color="var(--color-primary)" />
                </div>
                <div className="comment-content flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <span className="text-sm font-heading font-medium text-foreground">
                      {comment?.author}
                    </span>
                    <span className="text-xs text-muted-foreground">
                      {comment?.timestamp}
                    </span>
                  </div>
                  <p className="text-sm text-foreground">{comment?.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialInteractions;